<template>
  <AuthenticatedView :loading="userLoading" :current-user="currentUser" :has-result="!!userResult">
    <div>
      <AppHeader
        :user="currentUser"
        :profile-url="profileUrl"
        :chat-id="chatId"
        :from-id="fromId"
      />
      <div class="card">
        <ConstructorPanel :project-id="projectId" :chat-id="chatId" :from-id="fromId" />
      </div>
    </div>
  </AuthenticatedView>
</template>

<script setup>
import { computed } from 'vue'
import AppHeader from '../common/AppHeader.vue'
import AuthenticatedView from '../common/AuthenticatedView.vue'
import { useCurrentUser } from '@/composables/useCurrentUser'
import ConstructorPanel from './ConstructorPanel.vue'

const props = defineProps({
  projectId: { type: String, default: null },
  chatId: { type: String, default: null },
  fromId: { type: String, default: null },
})

const { currentUser, loading: userLoading } = useCurrentUser({
  fromId: props.fromId,
  removeLoadingOnComplete: true,
})
const userResult = computed(() => !userLoading.value)

const profileUrl = computed(() => {
  let url = '/profile'
  const params = []
  if (props.chatId) params.push(`chat_id=${encodeURIComponent(props.chatId)}`)
  if (props.fromId) params.push(`from_id=${encodeURIComponent(props.fromId)}`)
  if (params.length > 0) url += '?' + params.join('&')
  return url
})
</script>

<style scoped>
.card {
  overflow: visible;
}
</style>
